import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    padding: '0 20px',
    flexDirection: 'column',
    '& .premise' : {
      marginTop: 20,
    },
  },
  textarea: {
    marginTop: 10,
    resize: 'none',
    width: '100%',
    padding: 8,
    flexGrow: 1,
    borderRadius: '4px',
    border: 'solid 1px #c2c7ca',
  },
}))

export {useStyles as default}
